<div class="relative flex min-w-[220px] gap-x-2">
  <lib-input
    #dropdownControl
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    [label]="labelText()"
    labelPosition="above"
    [formControl]="innerControl"
    [state]="isError || showcaseEmailError() ? 'error' : 'normal'"
    [placeholder]="placeholderText()"
    [background]="'white'"
    [hint]="isError || showcaseEmailError() ? errorHintText() : hintText()"
    (enterEvent)="addShowcaseParticipant()"
    (click)="openDropdown()"
    (blur)="closeDropdown()"
  >
    @if (prefixIconSrc()) {
      <svg-icon [key]="prefixIconSrc()!" class="text-text-tertiary" leftIcon></svg-icon>
    }

    <svg-icon
      [class.opacity-0]="showcaseMode()"
      rightIcon
      (click)="onIconClick($event)"
      [key]="rightIconSrc()"
      class="cursor-pointer text-text-tertiary"
    ></svg-icon>
  </lib-input>
  @if (showcaseMode()) {
    <button type="button" class="btn-secondary mt-[6px] h-[42px]" (click)="addShowcaseParticipant()">
      {{ 'collab_new_collab_modal_collaboration_participant_showcase_add_button' | translate }}
    </button>
  }
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.offsetWidth"
    [cdkConnectedOverlayOrigin]="dropdownControl.inputContainer"
    [cdkConnectedOverlayOpen]="dropdownOpen()"
    [cdkConnectedOverlayPositions]="overlayPositionStrategy"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="onOverlayOutsideClick($event)"
  >
    <div
      #dropdownList
      class="flex w-full flex-col gap-3 overflow-hidden rounded-[28px] border-2 border-background-white bg-background-modal shadow-card backdrop-blur"
    >
      @if (!dropdownItems()) {
        @if (isLoading()) {
          <div class="flex items-center justify-center p-4">
            <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
          </div>
        } @else {
          <div class="flex items-center justify-center p-4">
            <p class="typo-h7-semibold text-text-primary">{{ noResultLabelText() }}</p>
          </div>
        }
      } @else if (dropdownItems() && !dropdownItems()?.length) {
        @if (isLoading()) {
          <div class="flex items-center justify-center p-4">
            <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
          </div>
        } @else {
          <div class="flex items-center justify-center p-4">
            <p class="typo-h7-semibold text-text-primary">{{ noResultLabelText() }}</p>
          </div>
        }
      } @else if (dropdownItems()) {
        <cdk-virtual-scroll-viewport
          libDynamicVirtualViewportHeight
          [items]="dropdownItems() ?? undefined"
          [itemSize]="32"
          [height]="dropdownHeight()"
          [style.max-height.px]="dropdownMaxHeight()"
          class="min-h-[32px]"
          minBufferPx="100"
          maxBufferPx="100"
          libInfiniteScrollList
          (endReached)="onEndReached()"
        >
          @if (dropdownItems(); as participants) {
            <ng-container *cdkVirtualFor="let participant of participants">
              @if (participant.type === ParticipantListItemType.GroupDivider) {
                <!-- leaving this in case we need something like this in the future -->
                <!-- @if (participant.divide) {
                  <div class="divider h-[1px] w-full bg-background-disabled"></div>
                }
                <p class="typo-h7-semibold text-text-primary">{{ participant.title }}</p> -->
              }
              @if (participant.type === ParticipantListItemType.Participant) {
                <button libInfiniteScrollListItem class="flex justify-between gap-2" (click)="selectItem(participant)">
                  <div class="flex items-center gap-2">
                    <lib-avatars [persons]="[participant]" [size]="32"></lib-avatars>
                    <div class="flex flex-col items-start">
                      <p class="typo-h4-light text-text-primary">{{ participant.firstName }} {{ participant.lastName }}</p>
                      <p class="typo-h7-light text-text-secondary">
                        @if (isPatient(participant)) {
                          {{ participant.pmsPatientId }}
                        }
                        @if (isProvider(participant)) {
                          {{ participant.email || participant.pmsId }}
                        }
                      </p>
                    </div>
                  </div>
                  @if (participant.status === EmployeeStatus.NOT_INVITED) {
                    <span class="typo-h5-semibold-5p text-primary-blue">{{ inviteLabelText() }}</span>
                  }
                </button>
              }
            </ng-container>

            @if (isLoading()) {
              <div class="flex items-center justify-center p-4">
                <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
              </div>
            }
          }
        </cdk-virtual-scroll-viewport>
      }
    </div>
  </ng-template>
</div>
